import { render, staticRenderFns } from "./productosNV.vue?vue&type=template&id=c9f047be&scoped=true"
import script from "./productosNV.vue?vue&type=script&lang=js"
export * from "./productosNV.vue?vue&type=script&lang=js"
import style0 from "./productosNV.vue?vue&type=style&index=0&id=c9f047be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f047be",
  null
  
)

export default component.exports